import { render, staticRenderFns } from "./bulk-upload.vue?vue&type=template&id=675b4f38&"
import script from "./bulk-upload.vue?vue&type=script&lang=js&"
export * from "./bulk-upload.vue?vue&type=script&lang=js&"
import style0 from "./bulk-upload.vue?vue&type=style&index=0&id=675b4f38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports